module.exports = __webpack_public_path__ + "img/mobilesystem5.68e82fe3.png";